import IDMGlobals from './../IDMGlobals';
const JWT = require("jsonwebtoken");

export default class IDMSessionAuthorization {
  /**
   * constructor - description
   *
   * @param  {type} token  description
   * @param  {type} groups description
   * @return {type}        description
   */
  constructor(token, groups, jwtAPIMode) {
    this.token = token;
    this.groupsMapping = groups;
    this.jwtAPIMode = jwtAPIMode;
    this._decodeToken();
  }
  /*public methods*/
  isTokenValid() {
    const validBody = (this.token && this._decoded && Object.keys(this._decoded).length > 0 && Object.keys(this._decoded.payload).length > 0 ? true : false);
    //if have valid body and token expiration is on future + gap!
    if (validBody && this._decoded.payload && this._decoded.payload.exp > ((Date.now()/1000) + (this.jwtAPIMode ? 0 : IDMGlobals.JWTExpirationGap))) return true;
    return false;
  }
  //Getters
  getTokenParam(param) { return this._decoded.payload[param]; }
  getClaims() { return this._decoded.payload['cognito:groups']; }
  getUserID() { return this._decoded.payload['custom:IDM_ID']; }
  getUserEmail() { return this._decoded.payload['email']; }
  /*
    @deprecated since version 4.3.2 in order to avoid it's usage
    when in use with federated identities that may bring another set of results other than
    the actual name saved on IDM DB
  */
  getFirstName() { 
    console.warn('[IDMClient] - session.authorization.getFirstName() is DEPRECATED, please avoid using it with FEDERATED identities!');
    return this._decoded.payload['given_name']; 
  }
  /*
    @deprecated since version 4.3.2 in order to avoid it's usage
    when in use with federated identities that may bring another set of results other than
    the actual name saved on IDM DB
  */
  getLastName() { 
    console.warn('[IDMClient] - session.authorization.getLastName() is DEPRECATED, please avoid using it with FEDERATED identities!');
    return this._decoded.payload['family_name']; 
  }
  //Query
  hasClaim(_claimName) {
    let _claim = this.groupsMapping[_claimName];
    if (_claim && this._decoded) return (this.getClaims().indexOf(_claim) != -1);
    else if (_claimName && this._decoded) return (this.getClaims().indexOf(_claimName) != -1);
    return false;
  }

  /*private methods*/
  _decodeToken() {
    try {
      this._decoded = JWT.decode(this.token, { complete: true });
    } catch (e) { console.error('Error while decoding JWT ', e); }
  }
}
